// Repair tickets' printed/displayed reference id is NOT the internal
// auto-increment id -- it's <2-digit year><2-digit month><internal id>,
// derived from the ticket's creation date (e.g. ticket 2071 created in
// August 2026 displays as "26082071"). The internal id is still what's used
// for URLs, API calls, and the database.
export function buildReportId(id, createdAt) {
  const d = new Date(createdAt);
  const yy = String(d.getFullYear()).slice(-2);
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${yy}${mm}${id}`;
}
